module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-120x120-a1eef47d75d9fd4357f4ab1b0055a4ea.png";